"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrganisationSummaryList = exports.OrganisationSummaryListDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var organisation_summary_1 = require("./organisation-summary");
var use_full_screen_state_1 = require("../../hooks/use-full-screen-state");
exports.OrganisationSummaryListDefaultProps = {
  items: []
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var OrganisationSummaryStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    background-position: bottom left;\n    padding: ", " 0;\n\n    &:last-child {\n      background: none;\n    }\n  "], ["\n    ", ";\n    background-position: bottom left;\n    padding: ", " 0;\n\n    &:last-child {\n      background: none;\n    }\n  "])), theme_1.theme.DOT_BG('h', 'line-mid', 2, 4), theme_1.theme.UNIT(6)),
  desktop: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-left: ", ";\n  "], ["\n    padding-left: ", ";\n  "])), theme_1.theme.UNIT(5)),
  last: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.isFullScreen && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      padding-left: 0 !important;\n    "], ["\n      padding-left: 0 !important;\n    "])));
  })
});
// -------- Components --------->
var My = {
  Container: styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  OrganisationSummary: (0, styled_components_1.default)(organisation_summary_1.OrganisationSummary)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), OrganisationSummaryStyles)
};
var OrganisationSummaryList = function (props) {
  var className = props.className,
    items = props.items;
  var isFullScreen = (0, use_full_screen_state_1.useFullScreenState)().isFullScreen;
  return items && items.length ? react_1.default.createElement(My.Container, {
    className: className
  }, items.map(function (item) {
    return react_1.default.createElement(My.OrganisationSummary, {
      isFullScreen: isFullScreen,
      key: item.id,
      entity: item
    });
  })) : null;
};
exports.OrganisationSummaryList = OrganisationSummaryList;
exports.OrganisationSummaryList.defaultProps = exports.OrganisationSummaryListDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;